export default "__VITE_ASSET__CKua1Oqu__"